import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import './common/rem';
import debounce from './common/debounce';
import '@/assets/common.css';

import { isTestEnv, getSensorsServerUrl, isWechat } from './common/util';

import VConsole from 'vconsole';

import SentryPlugin from './common/sentry'

import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);

if (isTestEnv()) {
  // eslint-disable-next-line
  const vConsole = new VConsole();
}

const sensorsServerUrl = getSensorsServerUrl(isTestEnv())
const sensors = window.sensorsDataAnalytic201505;
window.sensors = sensors;
sensors.init({
  server_url: sensorsServerUrl,
  // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
  heatmap_url: 'https://api-m.haohuan.com/public/asset/lib/sensors/heatmap.min.js',
  // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
  // web_url: 'https://api-m.haohuan.com/public/asset/lib/sensors/sensorsdata.min.js',
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    // 需要 JSSDK 版本号大于 1.7
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    // 需要 JSSDK 版本号大于 1.9.1
    scroll_notice_map: 'not_collect',
  },
  use_app_track: true,
});

if (isWechat()) {
  sensors.registerPage({
    PlatformType: 'web-H5',
  });
}

sensors.quick('autoTrack');

// 全局事件监听
// 通知上个view已经关闭
window.previousWebviewDidClosed = function (options) {
  console.log('通知上个view已经关闭', options);
};
// 后台到前台激活app时 ios会调用该方法
window.applicationWillEnterForeground = function (options) {
  console.log('后台到前台激活app时', options);
};
// 底部tab点击事件 安卓点击底部tab会调用
window.tabClick = function (options) {
  console.log('底部tab点击事件', options);
};
// onTabClick tab点击时调用
window.onTabClick = function(options) {
  console.log('onTabClick tab点击时', options);
}
// 后台进入前台事件
window.onForeground = function(options) {
  console.log('onForeground 进入app时', options);
}
// 监听客户端成功回调
window.nativeCallHandler = function(options) {
  console.log('监听客户端成功回调', options);
}

Vue.config.productionTip = false;
try {
  Vue.use(SentryPlugin, { router });
} catch (error) {
  console.log('sentry加载失败', error);
}
Vue.use(debounce);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
